import Widget                 from "lib/widget"
import { googleGeocomplete, componentForm }  from "servos/googlePlaces"


class GeocompletedAddress extends Widget {
  constructor({ root, selector = ".address", options = {} }) {
    super(root)
    this.selector = selector
    this.options  = options

    geocompleteAddress.call(this)
  }
}

const geocompleteAddress = function () {
  console.log('geocompleteAddress')
  const input = this.root.find(`:input${this.selector}`)
  googleGeocomplete.call(this, input, this.selector, this.options)
  input.on("geocomplete:result", (e, result) => {
    fillInForm.call(this, result)
  })
}

const fillInForm = function(result) {
  for (let key in componentForm) { this.root.find(`:input.${key}`).val(result[key] || "") }
}

const CUSTOM_ADDRESS_FIELDS_SELECTOR = ".street_number, .route, .locality, .administrative_area_level_1, .postal_code"

export const syncCustomAddressFields = function(root, selector = ".address") {
  root.on("input change", CUSTOM_ADDRESS_FIELDS_SELECTOR, function() {
    const line1 = [root.find(".street_number").val(), root.find(".route").val()].filter(Boolean).join(" ")
    const line2 = [root.find(".locality").val(), root.find(".administrative_area_level_1").val(), root.find(".postal_code").val()].filter(Boolean).join(" ")
    root.find(selector).val([line1, line2].filter(Boolean).join(", "))
  })
}

export default GeocompletedAddress
